export const THEME = {
    ink: '#10231F',
    forest: '#245B4E',
    mint: '#E4F1EC',
    paper: '#F6F7F3',
    gold: '#B7822C',
    red: '#A83D3D'
};
export const COPY = {
    productName: 'Defensive Allocation Workbench',
    subtitle: 'Anchored by defensive assets, generating allocation plans through explainable rules',
    dataFresh: 'Market snapshot up to date',
    dataStale: 'Market data is stale; new plan generation paused',
    researchOnly: 'For personal reference only;; historical data and scenario simulations do not guarantee future results.'
};
